module.exports = __webpack_public_path__ + "static/media/Logo-2-wh.7b1670e6.png";